<template>
  <div class="min-h-screen py-10 px-6">
    <div class="max-w-[1400px] mx-auto bg-white p-8 shadow-lg rounded-md">
      <!-- 제목 영역 -->
      <div class="flex items-center justify-between pb-4 border-b">
        <h2 class="text-2xl font-semibold text-gray-800">{{ notice.title }}</h2>
        <button @click="$router.go(-1)" class="px-4 py-2 text-sm font-medium text-violet-600 border border-violet-600 rounded hover:bg-violet-100">
          돌아가기
        </button>
      </div>

      <!-- 상세 내용 -->
      <div v-if="notice" class="mt-6 space-y-5">
        <!-- 본문 영역 -->
        <div class="flex flex-col">
          <dd class="p-6 bg-gray-50 rounded-lg text-gray-800 text-left break-words overflow-hidden border border-gray-200">
            <div class="ck-content prose prose-sm max-w-none
              prose-headings:text-gray-900 prose-headings:font-semibold
              prose-p:text-gray-700 prose-p:leading-7 prose-p:my-3
              prose-strong:text-gray-900
              prose-ul:my-4 prose-ul:pl-5 prose-li:my-1
              prose-ol:my-4 prose-ol:pl-5
              prose-a:text-violet-600 prose-a:underline
              prose-img:rounded-lg prose-img:my-4
              prose-table:border-collapse prose-table:w-full
              prose-th:bg-gray-100 prose-th:p-2 prose-th:border prose-th:border-gray-300
              prose-td:p-2 prose-td:border prose-td:border-gray-300"
              v-html="notice.content"></div>
          </dd>
        </div>

        <!-- 상세 내용 아래에 버튼 영역 -->
        <div v-if="canDelete" class="flex justify-center mt-8">
        <button
          @click="onDelete"
          class="px-6 py-2 text-sm font-medium text-red-600 border border-red-600 rounded hover:bg-red-100"
          :disabled="isDeleting"
        >
          {{ isDeleting ? '삭제 중...' : '삭제하기' }}
        </button>
      </div>


      </div>

      <div v-else class="text-gray-500 text-center mt-6">로딩 중...</div>

    </div>



  </div>
</template>

<script setup>
import '../../../styles/ckeditor-custom.scss';  
import {computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useRouter } from 'vue-router';


const store = useStore();
const route = useRoute();
const router = useRouter();
const user = computed(() => store.state.auth.user);
const isDeleting = ref(false);
const notice = ref({
  title: '',
  author: '',
  date: '',
  content: '',
  user_id :''
});

async function fetchDetail() {
  const insight_id = route.params.insight_id;
  await store.dispatch('insight/fetchInsightDetail', insight_id);
  const detail = store.getters['insight/insightDetail'];
   
  if (detail) {

    const formattedDate = new Date(detail.creation_date).toISOString().split('T')[0]; // YYYY-MM-DD 추출
 
    notice.value = {
      title: detail.title,
      author: detail.user_nm,
      date: formattedDate,
      content: convertOembedToIframe(detail.content), // 변환 적용
      user_id : detail.user_id
    };
    console.log(notice.value)
    console.log(user.value.pid)
 
  }
}

onMounted(fetchDetail);

function convertOembedToIframe(content) {
  return content.replace(
    /<oembed url="https:\/\/www\.youtube\.com\/(watch\?v=|shorts\/)([^"]+)"><\/oembed>/g,
    (match, type, videoId) => {
      return `
        <iframe width="560" height="315" 
          src="https://www.youtube.com/embed/${videoId}" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen>
        </iframe>`;
    }
  );
}

const canDelete = computed(() => {
  const n = notice.value
  const u = user.value   // ✅ 꼭 .value 사용!

  if (!n || !u) return false
  if (n.user_id == null || u.pid == null) return false

  const pid = String(u.pid)
  const owner = String(n.user_id) === pid
  const isException = pid === '383' || pid === '373'  || pid === '454'  // ✅ 예외 허용

  return owner || isException
})

async function onDelete() {
  if (!canDelete.value) {
    alert('삭제 권한이 없습니다.')
    return
  }

  if (!confirm('정말로 삭제하시겠습니까?')) return

  try {
    isDeleting.value = true
    const insight_id = route.params.insight_id
    await store.dispatch('insight/deleteInsight', insight_id);
    alert('삭제가 완료되었습니다.')
    await router.push({ name: 'INSIGHTBoard' })
  } catch (e) {
    console.error(e)
    alert('삭제 중 오류가 발생했습니다.')
  } finally {
    isDeleting.value = false
  }
}

 
</script>
